import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ROUTES } from "../../../core/config";

export const useLogout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const execute = async () => {
    try {
      await logout();
    } catch (err) {
      // même si backend down ou 404
      console.error("Logout error:", err);
    } finally {
      navigate(ROUTES.AUTH_ROUTES.LOGIN, { replace: true });
    }
  };

  return { logout: execute };
};